import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="user-widget-editor"
export default class extends Controller {
  static targets = ["display", "form", "input"]

  edit() {
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    this.inputTarget?.focus()
    this.inputTarget?.select?.()
  }

  cancel() {
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }

  submitEnd(event) {
    // If the update succeeded, Turbo will replace the frame with the display view.
    // If it failed (422), the server will re-render the editor in edit mode with errors.
    if (!event.detail.success) return

    // Defensive UX: if the server response doesn't visually change anything (e.g. same value),
    // still exit edit mode.
    this.cancel()
  }
}
